import gsap from 'gsap';

export default function initArticles() {
    const articles = document.querySelectorAll('.article');
    if (!articles.length) return;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    articles.forEach(article => {
        const image = article.querySelector('.article__image');
        const meta = article.querySelector('.article__meta');
        const btn = article.querySelector('.btn-text');

        const elementsToAnimate = [image, meta, btn].filter(Boolean);

        if (!elementsToAnimate.length) return;

        elementsToAnimate.forEach(el => {
            // Initial state
            gsap.set(el, {
                y: 30,
                opacity: 0
            });

            // Animation
            gsap.to(el, {
                scrollTrigger: {
                    trigger: el,
                    start: 'top 85%', // Trigger when the top of the element hits 85% of viewport height
                    once: true
                },
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: 'power3.out',
                clearProps: 'all' // Cleanup after animation finishes
            });
        });
    });
}
